import "@/App.css";
import { useState, useEffect } from "react";
import axios from "axios";
import Dashboard from "./pages/Dashboard";
import { Toaster } from "./components/ui/toaster";

const PANEL_PASSWORD = process.env.REACT_APP_RAQUEL_PASSWORD;

function LoginScreen({ onLogin, error }) {
  const [input, setInput] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin(input);
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "#0c0c0c",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "system-ui, sans-serif",
    }}>
      <div style={{
        background: "#0e3f4b",
        border: "1px solid #729790",
        borderRadius: "16px",
        padding: "48px 40px",
        width: "100%",
        maxWidth: "380px",
        display: "flex",
        flexDirection: "column",
        gap: "24px",
      }}>
        <div style={{ textAlign: "center" }}>
          <img
            src="/agentes-tu-codigo-base.webp"
            alt="Tu Código Base"
            style={{ height: "48px", display: "block", margin: "0 auto 16px auto" }}
            onError={(e) => { e.target.style.display = "none"; }}
          />
          <h1 style={{ color: "#cfb180", fontSize: "20px", fontWeight: "700", margin: 0 }}>
            Panel de Agentes
          </h1>
          <p style={{ color: "#729790", fontSize: "14px", marginTop: "6px" }}>
            Acceso restringido
          </p>
        </div>
        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <input
            type="password"
            placeholder="Contraseña"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            autoFocus
            style={{
              background: "#0c0c0c",
              border: error ? "1px solid #e05252" : "1px solid #729790",
              borderRadius: "8px",
              color: "#fffbef",
              fontSize: "15px",
              padding: "12px 16px",
              outline: "none",
              width: "100%",
              boxSizing: "border-box",
            }}
          />
          {error && (
            <p style={{ color: "#e05252", fontSize: "13px", margin: 0 }}>
              Contraseña incorrecta
            </p>
          )}
          <button
            type="submit"
            style={{
              background: "#bd9048",
              color: "#0c0c0c",
              border: "none",
              borderRadius: "8px",
              padding: "13px",
              fontSize: "15px",
              fontWeight: "700",
              cursor: "pointer",
              width: "100%",
            }}
          >
            Entrar
          </button>
        </form>
      </div>
    </div>
  );
}

function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("tcb_auth") === "1") {
      const pwd = sessionStorage.getItem("tcb_pwd");
      if (pwd) {
        axios.defaults.headers.common["X-Panel-Password"] = pwd;
      }
      setAuthenticated(true);
    }
  }, []);

  const handleLogin = (input) => {
    if (input === PANEL_PASSWORD) {
      axios.defaults.headers.common["X-Panel-Password"] = input;
      sessionStorage.setItem("tcb_auth", "1");
      sessionStorage.setItem("tcb_pwd", input);
      setAuthenticated(true);
      setError(false);
    } else {
      setError(true);
    }
  };

  useEffect(() => {
    if (authenticated && PANEL_PASSWORD) {
      axios.defaults.headers.common["X-Panel-Password"] = PANEL_PASSWORD;
    }
  }, [authenticated]);

  if (!authenticated) {
    return <LoginScreen onLogin={handleLogin} error={error} />;
  }

  return (
    <div className="App">
      <Dashboard />
      <Toaster />
    </div>
  );
}

export default App;
